import account from './account.json';
import permission from './permission.json';
import role from './role.json';

const en = {
  title: 'Access Control',
  name: 'Name',
  type: 'Type',
  account,
  role,
  permission,
};

export default en;
